import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
/* eslint-disable import/no-extraneous-dependencies */
import ProgressBar from 'progressbar.js';
/* eslint-enable import/no-extraneous-dependencies */

function PuzzleProgressBar({ progress, color = '#2196F3' }) {
  const containerRef = useRef(null);
  const barRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return undefined;

    // Create progress bar instance
    barRef.current = new ProgressBar.Line(containerRef.current, {
      strokeWidth: 4,
      easing: 'easeInOut',
      duration: 400,
      color,
      trailColor: '#E5E7EB',
      trailWidth: 4,
      svgStyle: { width: '100%', height: '100%' },
    });

    return () => {
      if (barRef.current) {
        barRef.current.destroy();
      }
    };
  }, [color]);

  useEffect(() => {
    if (barRef.current) {
      barRef.current.animate(progress / 100);
    }
  }, [progress]);

  return (
    <div
      ref={containerRef}
      className="w-full h-2"
      title={`${progress}% complete`}
    />
  );
}

PuzzleProgressBar.propTypes = {
  progress: PropTypes.number.isRequired,
  color: PropTypes.string,
};

PuzzleProgressBar.defaultProps = {
  color: '#2196F3',
};

export default PuzzleProgressBar;
